export const MAX_PDF_SIZE = 50 * 1024 * 1024;
export const ACCEPT_PDF_FILE_TYPES = 'application/pdf';
